<template>
	<b-row class="m-0">
		<b-col class="p-0">
			<b-row class="m-0">
				<b-col lg="6" md="12">
					<label class="mh-label">Search</label>
					<div class="field-with-icon">
						<b-input type="text" v-model="search" class="form-control"></b-input>
						<i class="mh-icon-search"></i>
					</div>
				</b-col>
			</b-row>
			<b-row class="m-0">
				<b-col cols="12">
					<b-alert show variant="primary">Email & Push Notifications will be sent to the following users</b-alert>
				</b-col>
			</b-row>
			<b-row v-if="requiredQualifications != ''" class="m-0">
				<b-col cols="12">
					<b-alert show variant="warning"><b>Required Qualifications:</b> {{requiredQualifications}}</b-alert>
				</b-col>
			</b-row>
			<b-row class="m-0">
				<b-col lg="6" md="12">
					<input type="checkbox" id="sendSms" v-model="sendSms" />
					<label for="sendSms"> Send SMS</label>
				</b-col>
			</b-row>
			<b-row class="m-0">
				<b-col lg="6" md="12">
					<b-form-checkbox id="chkSelectAll" style="display:inline-block; padding-left:0;" v-model="selectAll" :value="true" :unchecked-value="false" @change.native="onSelectAllChange()" />
					<label for="chkSelectAll"> {{selectAll ? "Unselect" : "Select"}} All</label>
				</b-col>
			</b-row>
			<b-row class="m-0">
				<b-col md="12">
					<data-table v-bind="bindings"
								:perPageSizes="[1000]"
								:defaultPerPage="1000"
								:showPerPage="false"
								:showEntriesInfo="false"
								:showSearchFilter="false"
								:showPagination="false"
								:showDownloadButton="false"
								:text="{ emptyTableText: 'There is nothing to show' }"
								sortingMode="single"
								tableClass="table table-curved dataTable light"
								ref="dataTable" />
				</b-col>
			</b-row>
			<b-row class="mr-0 ml-0 mh-action-nav">
				<b-col cols="6">
					<button class="btn btn-grey" @click="$emit('close-form')">Close</button>
				</b-col>
				<b-col cols="6">
					<button class="btn btn-yellow" @click="publishShiftAvailability">Publish</button>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	import { bus } from './../../main';
	import SortingIcon from "./SortingIcon"
	import HtmlColumn from "./HtmlColumn"
	import CheckboxColumn from "./CheckboxColumn"

    export default {
		name: 'PublishShiftAvailability',
		components: {
			SortingIcon,
			HtmlColumn
		},
		props: {
			serviceScheduleIds: null
		},
		data() {
			return {
				search: "",
				sendSms: false,
				selectAll: false,
				publishShiftAvailabilitySelectEmployees: []
			}
		},
		mounted() {
			this.$store.dispatch(
				"Users/GetRosteringStaff",
				{
					ids: this.serviceScheduleIds,
					stafftype: 0,
					availability: 2,
					position: 0,
					additionaluserfields: ""
				})

			bus.$off('publishShiftAvailabilityCheckboxClick')
			bus.$on('publishShiftAvailabilityCheckboxClick', obj => { this.publishShiftAvailabilityCheckboxClick(obj) })
		},
		computed: {
			rosteringStaff: function () {
				return this.$store.state.Users.rosteringStaff
			},
			requiredQualifications: function () {
				return this.$store.state.Users.qualifications
			},
			records: function () {
				return this.rosteringStaff
					.filter(x => {
						return (x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.preferred + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.available + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.position + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.traveldistance + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.suburbfrom + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
							|| (x.suburbto + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
					})
					.map(x => {
						var publishShiftAvailabilitySelectEmployees = this.publishShiftAvailabilitySelectEmployees;
						var checked = publishShiftAvailabilitySelectEmployees.indexOf(x.id) > -1

						return {
							checkbox: {
								id: x.id,
								checked: checked,
								disabled: false,
								emit: "publishShiftAvailabilityCheckboxClick"
							},
							id: x.id,
							name: x.name,
							preferred: x.preferred,
							available: x.available,
							position: x.position,
							traveldistance: x.traveldistance,
							traveltime: x.traveltime,
							suburbfrom: x.suburbfrom,
							suburbto: x.suburbto
						}
					})
			},
			columns: function () {
				var columns = [
					{ key: "", title: "", searchable: false, sortable: false, component: CheckboxColumn },
					{ key: "name", title: "Name", searchable: true, sortable: true, component: HtmlColumn, sortingFunction: function (a, b) { return moment(b.date, "DD MMM, ddd").toDate() - moment(a.date, "DD MMM, ddd").toDate(); } },
					{ key: "preferred", title: "Preferred", searchable: true, sortable: true, component: HtmlColumn },
					{ key: "available", title: "Available", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "position", title: "Position", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:15vw;" },
					{ key: "traveldistance", title: "Travel Distance", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "traveltime", title: "Travel Time", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "suburbfrom", title: "Suburb From", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "suburbto", title: "Suburb To", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			pageSize: function () {
				return this.records.length
			}
		},
		methods: {
			onSelectAllChange: function() {
				if (this.selectAll) {
					this.publishShiftAvailabilitySelectEmployees = this.records.map(x => x.id)
				}
				else {
					this.publishShiftAvailabilitySelectEmployees = []
				}
			},
			publishShiftAvailabilityCheckboxClick: function (obj) {
				if (obj.checkbox.checked) {
					this.publishShiftAvailabilitySelectEmployees.push(obj.checkbox.id)
				}
				else {
					this.publishShiftAvailabilitySelectEmployees = this.publishShiftAvailabilitySelectEmployees.filter(x => x !== obj.checkbox.id)
				}
			},
			publishShiftAvailability: function () {
				if (this.publishShiftAvailabilitySelectEmployees.length < 1) {
					this.$store.commit("Toasts/showError", { title: "Employee", content: "Select at-lease 1 employee" })

					return false
				}

				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to publish this shift's availability?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/publishShiftAvailability",
							{
								ids: this.serviceScheduleIds,
								uids: this.publishShiftAvailabilitySelectEmployees.join(),
								sendSms: this.sendSms
							})
							.then(() => {
								this.$store.commit("Toasts/showSuccess", { title: "Published", content: "Shift availability published" })
								this.$emit('close-form')

								this.getShifts()
							})
					},
					cancelCallback: null
				})
			}
		}
    }
</script>

<style scoped>
</style>